import { baseMutations, baseActions } from '../functions'
/* eslint-disable */
export default {
  namespaced: true,
  state: {
    // Info
    items: [],
    title: 'Equipamentos',
    name: 'Equipamentos',
    loading: true,

    // Menu
    menu: {
      title: 'Equipamentos',
      icon: { key: 'tools', custom: true }
    },

    // Routes - Components actions
    actions: {
      // Main Action
      component: 'Cards.Equipamentos', // Alterado para 'Cards.Equipamentos'
      props: { title: 'Equipamentos com acesso a plataforma', module: 'users', modelKey: 'profile' }
    },

    // API Get index
    get: {
      urn: 'Equipments', // Rota para buscar equipamentos
      response: 'equipamentos' // Resposta esperada
    },

    // Models
    models: {
      profile: [
        { key: 'name', label: 'Nome', slot: 'Nome' }
      ]
    }
  },
  mutations: Object.assign({}, baseMutations, {
    // ...
  }),
  actions: Object.assign({}, baseActions, {
    // ...
    // ...
  })
}
